import Vue from 'vue'
import Router from 'vue-router'
import store from './store/config'
import VueCookie from 'vue-cookie'
import menuList from './components/menus'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    meta: { title: 'Login' },
    component: () => import('./views/Auth/Login.vue'),
    beforeEnter (from, to, next) {
      if (!VueCookie.get('kilab_token')) {
        next()
      } else {
        next('/customers')
      }
    }
  }, {
    path: '/resetpassword',
    name: 'resetpassword',
    meta: { title: 'Reset password' },
    component: () => import('./views/Auth/ResetPassword.vue')
  }, {
    path: '/forgotpassword',
    name: 'forgotpassword',
    meta: { title: 'Forgot password' },
    component: () => import('./views/Auth/ForgotPassword.vue')
  }, {
    path: '/dashboard',
    name: 'dashboard',
    meta: { title: 'Dashboard' },
    component: () => import('./views/Dashboard/Index.vue')
  }, {
    path: '/customers',
    component: () => import('./views/Customer/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'customers',
      component: () => import('./views/Customer/List.vue')
    },
    {
      path: 'actions/:crm_id?',
      name: 'customers_actions',
      component: () => import('./views/Customer/Action.vue')
    }, {
      path: 'edit/:crm_id',
      component: () => import('./views/Customer/Details/View.vue'),
      children: [{
        path: '/',
        component: () => import('./views/Customer/Details/EditView.vue'),
        children: [{
          path: 'view',
          name: 'view_crm_actions',
          component: () => import('./views/Customer/Action.vue')
        }, {
          path: 'documents',
          name: 'documents_crm',
          component: () => import('./views/Customer/Details/Documents.vue')
        }, {
          path: 'contacts',
          name: 'crm_contacts',
          component: () => import('./views/Customer/Details/Contacts.vue')
        }, {
          path: 'address',
          name: 'crm_address',
          component: () => import('./views/Customer/Details/Address.vue')
        }, {
          path: 'orders',
          name: 'crm_orders',
          component: () => import('./views/Customer/Details/Order.vue')
        }, {
          path: 'addons',
          name: 'crm_addons',
          component: () => import('./views/Customer/Details/Addons.vue')
        }, {
          path: 'netprices',
          name: 'crm_prices',
          component: () => import('./views/Customer/Details/NetPrice.vue')
        }]
      }]
    }]
  }, {
    path: '/users',
    component: () => import('./views/User/Index.vue'),
    meta: { requiresAuth: true, title: 'Bruker' },
    children: [{
      path: '/',
      name: 'users',
      meta: { requiresAuth: true, title: 'Bruker' },
      component: () => import('./views/User/List.vue')
    }, {
      path: 'actions/:user_id?',
      name: 'user_actions',
      component: () => import('./views/User/Action.vue'),
      beforeEnter (from, to, next) {
        const userData = VueCookie.get('kilab_user') ? JSON.parse(VueCookie.get('kilab_user')) : {}
        if (userData.role === 2 || userData.role === 3) {
          next('/dashboard')
        } else {
          next()
        }
      }
    }, {
      path: '/user_profile',
      name: 'user_profile',
      component: () => import('./views/User/Profile.vue'),
      beforeEnter (from, to, next) {
        if (store.state.userDetails.id !== -100) {
          next()
        } else {
          next(from.path)
        }
      }
    }]
  }, {
    path: '/user_roles',
    component: () => import('./views/UserRole/List.vue'),
    meta: { requiresAuth: true, title: 'Brukerrolle' }
  }, {
    path: '/deviation_measures',
    component: () => import('./views/DeviationMeasures/List.vue'),
    meta: { requiresAuth: true, title: 'Measures' }
  }, {
    path: '/measures_status',
    component: () => import('./views/MeasureStatus/List.vue'),
    meta: { requiresAuth: true, title: 'Measures status' }
  }, {
    path: '/measure_category',
    component: () => import('./views/DeviationMeasureCategory/List.vue'),
    meta: { requiresAuth: true, title: 'Measures category' }
  }, {
    path: '/deviation_category',
    component: () => import('./views/DeviationCategory/List.vue'),
    meta: { requiresAuth: true, title: 'Avvikskategori' }
  }, {
    path: '/deviation_status',
    component: () => import('./views/DeviationStatus/List.vue'),
    meta: { requiresAuth: true, title: 'Status' }
  }, {
    path: '/deviation_location',
    component: () => import('./views/DeviationLocation/List.vue'),
    meta: { requiresAuth: true, title: 'Lokasjon' }
  }, {
    path: '/product_groups',
    component: () => import('./views/ProductGroup/List.vue'),
    meta: { requiresAuth: true, title: 'Product groups' }
  }, {
    path: '/product_units',
    component: () => import('./views/ProductUnit/List.vue'),
    meta: { requiresAuth: true, title: 'Product units' }
  }, {
    path: '/priorities',
    component: () => import('./views/Priorities/List.vue'),
    meta: { requiresAuth: true, title: 'Prioriteringer' }
  }, {
    path: '/categories',
    component: () => import('./views/TicketCategory/List.vue'),
    meta: { requiresAuth: true, title: 'Ticket' }
  }, {
    path: '/ticket_status',
    component: () => import('./views/TicketStatus/List.vue'),
    meta: { requiresAuth: true, title: 'Ticket' }
  }, {
    path: '/ticket_types',
    component: () => import('./views/TicketType/List.vue'),
    meta: { requiresAuth: true, title: 'Ticket' }
  }, {
    path: '/groups',
    component: () => import('./views/Group/List.vue'),
    meta: { requiresAuth: true, title: 'Gruppe' }
  }, {
    path: '/tickets',
    component: () => import('@/views/Tickets/Index.vue'),
    meta: { requiresAuth: true, title: 'Tickets' },
    children: [{
      path: '/',
      name: 'ticket_list',
      meta: { requiresAuth: true, title: 'Tickets' },
      component: () => import('@/views/Tickets/List.vue')
    }, {
      path: 'create',
      name: 'create',
      meta: {},
      component: () => import('@/views/Tickets/CreateTicket.vue')
    }, {
      path: 'actions/:ticket_id?',
      name: 'action',
      component: () => import('@/views/Tickets/Action.vue')
    }]
  }, {
    path: '/mail_configuration',
    component: () => import('./views/MailConfiguration/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'mail_configuration',
      component: () => import('./views/MailConfiguration/List.vue')
    },
    {
      path: 'actions/:id?',
      name: 'mail_configuration_actions',
      component: () => import('./views/MailConfiguration/Action.vue')
    }]
  }, {
    path: '/mailaddressfilter',
    meta: { requiresAuth: true, adminLevel: true, restrictedFeature: true, value: 11 },
    component: () => import('@/views/TicketsMailAddressFilter/Index.vue')
  }, {
    path: '/tickets-advanced-settings',
    meta: { requiresAuth: true, adminLevel: true, restrictedFeature: true, value: 11 },
    component: () => import('@/views/TicketsAdvancedSettings/Advanced.vue')
  }, {
    path: '/currencies',
    component: () => import('./views/Currency/Index.vue'),
    meta: { requiresAuth: true, title: 'Valutakurser' },
    children: [{
      path: '/',
      name: 'currencies',
      meta: { requiresAuth: true, title: 'Valutakurser' },
      component: () => import('./views/Currency/List.vue')
    }, {
      path: 'actions/:currency_id?',
      name: 'currency_actions',
      component: () => import('./views/Currency/Action.vue')
    }]
  }, {
    path: '/hse',
    component: () => import('./views/HSE/Index.vue'),
    meta: { requiresAuth: true, title: 'HSE' },
    children: [{
      path: '/',
      name: 'hse',
      meta: { requiresAuth: true, title: 'HSE' },
      component: () => import('./views/HSE/List.vue')
    }]
  }, {
    path: '/ticketing_configuration',
    component: () => import('./views/SystemConfiguration/Action.vue'),
    meta: { requiresAuth: true, title: 'Ticket' }
  }, {
    path: '/deviations',
    component: () => import('./views/Deviation/Index.vue'),
    meta: { requiresAuth: true, title: 'Avvik' },
    children: [{
      path: '/',
      name: 'deviations',
      meta: { requiresAuth: true, title: 'Avvik' },
      component: () => import('./views/Deviation/List.vue')
    },
    {
      path: 'actions/:deviation_id?',
      name: 'deviations_actions',
      component: () => import('./views/Deviation/Action.vue')
    }]
  }, {
    path: '/onedrive_setting',
    component: () => import('./views/OneDriveSetting/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/onedrive_redirect',
    component: () => import('./views/OneDriveSetting/ODRedirect.vue'),
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/sharepoint',
    component: () => import('./views/SharePointSetting/Action.vue'),
    meta: { requiresAuth: true }
    // children: [{
    //   path: '/',
    //   name: 'sharepointSetting',
    //   component: () =>
    // },
    // {
    //   path: '/sharepoint_credential',
    //   component: () => import('./views/SharePointCredential/Action.vue'),
    //   meta: { requiresAuth: true }
    // }]
  }, {
    path: '/crm_priorities',
    component: () => import('./views/CrmPriorities/List.vue'),
    meta: { requiresAuth: true, title: 'CRM' }
  }, {
    path: '/crm_shipments',
    component: () => import('./views/CrmShipments/List.vue'),
    meta: { requiresAuth: true, title: 'CRM' }
  }, {
    path: '/crm_industries',
    component: () => import('./views/CrmIndustries/List.vue'),
    meta: { requiresAuth: true, title: 'CRM' }
  }, {
    path: '/permissions',
    component: () => import('./views/Permission/List.vue'),
    meta: { requiresAuth: true, isSuperAdmin: true, title: 'Permissions' }
  }, {
    path: '/salesaccounts',
    component: () => import('./views/SalesAccount/List.vue'),
    meta: { requiresAuth: true, title: 'Salgskonto' }
  }, {
    path: '/settings/warehouse',
    component: () => import('./views/WarehouseSettings/Index.vue'),
    meta: { requiresAuth: true, title: 'Lager' },
    children: [{
      path: '/',
      name: 'warehouse',
      component: () => import('./views/WarehouseSettings/List.vue')
    }]
  }, {
    path: '/warehouse_location',
    component: () => import('./views/WarehouseLocation/Index.vue'),
    meta: { requiresAuth: true, title: 'Lagerlokasjon' },
    children: [{
      path: '/',
      name: 'warehouselocation',
      component: () => import('./views/WarehouseLocation/List.vue')
    }]
  }, {
    path: '/grossmargins',
    component: () => import('./views/GrossMargin/List.vue'),
    meta: { requiresAuth: true, title: 'Avanse' }
  }, {
    path: '/discountgroups',
    component: () => import('./views/DiscountGroups/Index.vue'),
    meta: { requiresAuth: true, title: 'Rabattgruppe' }
  }, {
    path: '/invoices',
    component: () => import('./views/GlobalInvoice/List.vue'),
    meta: { requiresAuth: true, title: 'Faktura' }
  }, {
    path: '/orders',
    component: () => import('./views/Order/View.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '',
      name: 'order_list',
      component: () => import('./views/Order/List.vue')
    }, {
      path: 'actions/:order_id?',
      name: 'orders_actions',
      component: () => import('./views/Order/Actions.vue')
    }, {
      path: 'edit/:order_id',
      component: () => import('./views/Order/Edit/View.vue'),
      children: [{
        path: '/',
        component: () => import('./views/Order/Edit/EditView.vue'),
        children: [{
          path: 'view',
          name: 'view_actions',
          component: () => import('./views/Order/Actions.vue')
        }, {
          path: 'materials',
          name: 'materials',
          component: () => import('./views/Order/Edit/Materials.vue')
        }, {
          path: 'deviations',
          name: 'deviations_list',
          component: () => import('./views/Deviation/List.vue')
        }, {
          path: 'checklist',
          name: 'checklist',
          component: () => import('./views/Order/Edit/Checklist.vue')
        }, {
          path: 'certificate',
          name: 'certificate',
          component: () => import('./views/Order/Edit/Certificate.vue')
        }, {
          path: 'documents',
          name: 'documents',
          component: () => import('./views/Order/Edit/Documents.vue')
        }, {
          path: 'invoice',
          component: () => import('./views/Order/Invoice/Index.vue'),
          children: [{
            path: '/',
            name: 'invoice',
            component: () => import('./views/Order/Invoice/List.vue')
          }, {
            path: 'actions/:invoice_id?',
            name: 'invoice_actions',
            component: () => import('./views/Order/Invoice/Action.vue')
          }, {
            path: 'creditnote/:invoice_id?',
            name: 'credit_actions',
            component: () => import('./views/Order/Invoice/CreditNote.vue')
          }]
        }]
      }]
    }]
  }, {
    path: '/general_settings',
    component: () => import('./views/GeneralSettings/Index.vue'),
    meta: { requiresAuth: true, title: 'Settings' }
  }, {
    path: '/invoice_settings',
    component: () => import('./views/InvoiceSettings/Index.vue'),
    meta: { requiresAuth: true, title: 'Settings' }
  }, {
    path: '/w_h',
    component: () => import('./views/Warehouse/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: 'stocks',
      name: 'stocklist',
      component: () => import('./views/Warehouse/Stock/List.vue')
    }, {
      path: 'products',
      component: () => import('./views/Warehouse/Product/Index.vue'),
      children: [{
        path: '/',
        name: 'warehouse_products',
        component: () => import('./views/Warehouse/Product/List.vue')
      }, {
        path: 'actions/:product_id?',
        name: 'warehouse_products_actions',
        component: () => import('./views/Warehouse/Product/Action.vue')
      }]
    }, {
      path: 'ccsheet',
      component: () => import('./views/Warehouse/CCSheet/Index.vue'),
      children: [{
        path: '/',
        name: 'ccsheet',
        component: () => import('./views/Warehouse/CCSheet/List.vue')
      }, {
        path: 'actions/:sheet_id?/:has_edit?',
        name: 'ccsheet_actions',
        component: () => import('./views/Warehouse/CCSheet/Action.vue')
      }, {
        path: 'adjustment_order/:sheet_id',
        name: 'sheet_adjustment',
        component: () => import('./views/Warehouse/CCSheet/AdjustmentOrder.vue')
      }]
    }, {
      path: 'order',
      component: () => import('./views/Warehouse/Order/Index.vue'),
      children: [{
        path: '/',
        name: 'warehouse_order',
        component: () => import('./views/Warehouse/Order/List.vue')
      }, {
        path: 'supplierorder/actions/:supp_id?',
        name: 'supporder_actions',
        component: () => import('./views/Warehouse/Order/SupplierOrder.vue')
      }, {
        path: 'lowstockproposal',
        name: 'low_stock_proposal',
        component: () => import('./views/Warehouse/Order/LowStockProposal.vue')
      }, {
        path: 'adjustmentorder/actions/:adjust_id?',
        name: 'adjustorder_actions',
        component: () => import('./views/Warehouse/Order/AdjustmentOrder.vue')
      }, {
        path: 'returnorder/actions/:return_id?',
        name: 'returnorder_actions',
        component: () => import('./views/Warehouse/Order/ReturnOrder.vue')
      }, {
        path: 'transferorder/actions/:transfer_id?',
        name: 'transferorder_actions',
        component: () => import('./views/Warehouse/Order/TransferOrder.vue')
      }]
    }]
  }, {
    path: '/reports',
    component: () => import('./views/Reports/Index.vue'),
    meta: { requiresAuth: true, title: 'Reports' }
  }, {
    path: '/payment_terms',
    component: () => import('./views/PaymentTerms/List.vue'),
    meta: { requiresAuth: true, title: 'Payment terms' }
  }, {
    path: '/delivery_terms',
    component: () => import('./views/DeliveryTerms/List.vue'),
    meta: { requiresAuth: true, title: 'Delivery terms' }
  }, {
    path: '/checklist_templates',
    component: () => import('@/views/Checklist/Settings/Templates/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'templates',
      component: () => import('@/views/Checklist/Settings/Templates/List.vue')
    }]
  }, {
    path: '/properties',
    meta: { requiresAuth: true },
    component: () => import('@/views/Checklist/Settings/Properties.vue')
  }, {
    path: '/document_builder',
    component: () => import('@/views/Documents/Report/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'document_templates',
      component: () => import('@/views/Documents/Report/List.vue')
    }, {
      path: 'actions/:report_id?',
      name: 'doc_builder',
      component: () => import('@/views/Documents/Report/Actions.vue')
    }]
  }, {
    path: '/document_template',
    meta: { requiresAuth: true },
    component: () => import('@/views/Documents/Template.vue')
  }, {
    path: '/oauth/microsoft',
    meta: { requiresAuth: true },
    component: () => import('@/views/OAuth/Ticket.vue')
  }]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title
  else document.title = 'Kilab Web'
  const userData = VueCookie.get('kilab_user') ? JSON.parse(VueCookie.get('kilab_user')) : {}
  if (userData.role === 3) {
    const menuObj = menuList.find(x => x.to === to.path || (x.hasChildren ? x.children.find(y => y.to === to.path) : false))
    if (menuObj && menuObj.hideForTechRole) next('/customers')
  } else if (userData.role === 2) {
    const menuObj = menuList.find(x => x.to === to.path || (x.hasChildren ? x.children.find(y => y.to === to.path) : false))
    if (menuObj && menuObj.hideForOffice) next('/customers')
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!VueCookie.get('kilab_token')) {
      store.dispatch('logout')
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else next()
  } else next()
})

export default router
